<div class="msh-band">
  <div class="msh-band-inner">
    <header class="msh-title-block">
      <h1 class="msh-title">{{ title }}</h1>
      <p class="msh-subtitle">{{ subtitle }}</p>
    </header>

    <div class="msh-controls-row">
      <div class="msh-search">
        <i class="material-icons msh-search-icon" aria-hidden="true">search</i>
        <input
          type="text"
          class="msh-search-input"
          placeholder="Search materials..."
          [ngModel]="searchText"
          (ngModelChange)="onSearchInput($event)"
          (keyup.enter)="onSearchEnter()"
          aria-label="Search materials"
        />
        <button
          *ngIf="searchText"
          type="button"
          class="msh-search-clear"
          (click)="onSearchClear()"
          aria-label="Clear search"
        >
          <i class="material-icons" aria-hidden="true">close</i>
        </button>
      </div>

      <div class="msh-sort">
        <button
          type="button"
          class="msh-pill msh-sort-trigger"
          [matMenuTriggerFor]="sortMenu"
          aria-label="Sort materials"
        >
          <i class="material-icons msh-pill-icon" aria-hidden="true">swap_vert</i>
          <span class="msh-pill-label">{{ currentSortLabel }}</span>
          <i class="material-icons msh-pill-chevron" aria-hidden="true">expand_more</i>
        </button>
        <mat-menu #sortMenu="matMenu" xPosition="before" class="msh-sort-menu">
          <button
            *ngFor="let option of sortOptions"
            mat-menu-item
            type="button"
            [disabled]="option.disabled"
            [class.is-active]="option.key === sort"
            (click)="onSortPick(option)"
          >
            <span>{{ option.label }}</span>
            <i *ngIf="option.key === sort && !option.disabled" class="material-icons msh-sort-check" aria-hidden="true">check</i>
          </button>
        </mat-menu>
      </div>

      <button
        type="button"
        class="msh-pill msh-filters-btn"
        (click)="onFiltersClick()"
        aria-label="Open advanced filters"
      >
        <i class="material-icons msh-pill-icon" aria-hidden="true">tune</i>
        <span class="msh-pill-label">Filters</span>
        <span *ngIf="filtersBadgeCount > 0" class="msh-filters-badge" aria-label="{{ filtersBadgeCount }} active panel filters">{{ filtersBadgeCount }}</span>
      </button>
    </div>

    <div class="msh-chips" *ngIf="materialCategories?.length">
      <button
        type="button"
        class="msh-chip"
        [class.is-active]="isCategoryActive('')"
        (click)="onChipClick('')"
      >
        All
      </button>

      <button
        *ngFor="let category of visibleCategories"
        type="button"
        class="msh-chip"
        [class.is-active]="isCategoryActive(category?.name)"
        (click)="onChipClick(category?.name)"
      >
        {{ category?.name }}
      </button>

      <button
        *ngIf="overflowCategories.length"
        type="button"
        class="msh-chip msh-chip-more"
        [matMenuTriggerFor]="moreMenu"
        aria-label="Show more categories"
      >
        + {{ overflowCategories.length }} more
      </button>

      <mat-menu #moreMenu="matMenu" class="msh-more-menu">
        <button
          *ngFor="let category of overflowCategories"
          mat-menu-item
          type="button"
          [class.is-active]="isCategoryActive(category?.name)"
          (click)="onChipClick(category?.name)"
        >
          {{ category?.name }}
        </button>
      </mat-menu>
    </div>
  </div>
</div>
